import $ from "jquery"
import {
  getAllColsUidInLayoutComponent,
  getCookie,
  handleFindLayoutComponentOptions,
  getAllElementsInColsInLayoutComponent,
  isSsrPage
} from "utils"
class loginLayoutComponentClass {
  constructor(val) {
    this.content = val
    this.isHeader = false
  }
  async init() {
    this.initWatchers()
    const that = this
    // if (this.content.reload) {
    //   const oldReload = this.content.reload
    //   async function proxyReload() {
    //     await oldReload.call(that.content)
    //     that.initWatchers()
    //   }
    //   this.content.reload = proxyReload.bind(this.content)
    // }
    let uid
    let arr,
      reg1 = new RegExp("(^| )UID=([^;]*)(;|$)")
    // let myCookie = await getCookie("fid,website_fid,UID", this.content)
    let myCookie = this.content.$store.state.states.myCookie
    if (myCookie.UID) {
      uid = myCookie.UID
    } else {
      uid = null
    }
    // if ((arr = document.cookie.match(reg1))) {
    //   uid = unescape(arr[2])
    // } else {
    //   uid = null
    // }
    const loginLayouMsg = {
      container_id: this.content.myid.container_id,
      rect_id: this.content.myid.rect_id,
      elementInAutoLayoutId: this.content.myid.elementInAutoLayoutId,
      path: this.content.myid.path
    }
    // // 兼容旧的登录组件不能上传和收藏样式
    const bigScreen = this.content.request_prefix === "bigScreen" || this.content.isBigScreenPreview()
    if (!bigScreen && this.content.options && !this.content.options.hasOwnProperty("isSystemComponent")) {
      const menuName = this.content.request_prefix === "stage"?'menu':'appMenu'
      const moduleTypes = this.content.$store.state[menuName].menu.moduleTypes
      const componentTypeId = moduleTypes.find(item=>item.name === '登录组件')?.encId
      // "encId": gaphic.subs[0].encId, // 是否需要
      this.content.$changeOptionsEV(
        [true, true, true, true,componentTypeId],
        ["isSystemComponent", "isDefaultComponent", "isCustomComponent", "isIndependenceComponent",'componentTypeId'],
        false,
        null,
        loginLayouMsg,
        true
      )
    }
    if (this.content.isBigScreenPreview()) {
      Array.from(this.content.$el.getElementsByClassName("other_content")).forEach(item => {
        item.style.display = "none"
      })
    }
    this.content.$el.style.overflow = "visible"
    // const editStageAddLoginBtn = document.createElement("span")
    // editStageAddLoginBtn.innerHTML = "未登录"
    // editStageAddLoginBtn.classList.add("empty-layout-outcontainer-login-btn" + this.content.myid.rect_id)
    // editStageAddLoginBtn.style.display = "inline-block"
    // editStageAddLoginBtn.style.height = "40px"
    // editStageAddLoginBtn.style.lineHeight = "40px"
    // editStageAddLoginBtn.style.padding = "0 10px"
    // editStageAddLoginBtn.style.cursor = "pointer"
    // const editStageAddExitBtn = document.createElement("span")
    // editStageAddExitBtn.innerHTML = "登录后"
    // editStageAddExitBtn.classList.add("empty-layout-outcontainer-exit-btn" + this.content.myid.rect_id)
    // editStageAddExitBtn.style.display = "inline-block"
    // editStageAddExitBtn.style.height = "40px"
    // editStageAddExitBtn.style.lineHeight = "40px"
    // editStageAddExitBtn.style.padding = "0 10px"
    // editStageAddExitBtn.style.cursor = "pointer"
    // if (
    //   this.content.$el.getElementsByClassName(".empty-layout-outcontainer-exit-btn" + this.content.myid.rect_id)
    //     .length == 0
    // ) {
    //   this.content.$el.after(editStageAddExitBtn)
    // }
    // if (
    //   this.content.$el.getElementsByClassName(".empty-layout-outcontainer-login-btn" + this.content.myid.rect_id)
    //     .length == 0
    // ) {
    //   this.content.$el.after(editStageAddLoginBtn)
    // }
    // document
    //   .getElementsByClassName("empty-layout-outcontainer-login-btn" + this.content.myid.rect_id)[0]
    //   .addEventListener("click", function () {
    //     that.content.$changeOptionsEV(0, "activeIndex", false, null, { ...loginLayouMsg })
    //   })
    // document
    //   .getElementsByClassName("empty-layout-outcontainer-exit-btn" + this.content.myid.rect_id)[0]
    //   .addEventListener("click", function () {
    //     that.content.$changeOptionsEV(1, "activeIndex", false, null, { ...loginLayouMsg })
    //   })
    let rectAttr = this.content.getRectAttribute.call(this.content, loginLayouMsg)?.options
    if (rectAttr && loginLayouMsg.elementInAutoLayoutId !== undefined && rectAttr.innerElement === "cxAutoLayout") {
      rectAttr = this.content.getAttrById(this.content.$store.state[this.content.request_prefix], loginLayouMsg)
    }
    const loginPOptions = [rectAttr.rows[0]]
    const loginUid = getAllColsUidInLayoutComponent(loginPOptions)[0]
    const loginLlementInLayout = handleFindLayoutComponentOptions(loginPOptions, loginUid)
    // const loginIds = loginLlementInLayout.map(it => Object.assign({elementInLayoutId:it.elementInLayoutId,uid:loginUid},loginLayouMsg))
    // const loginIdsStr = loginIds.map(it => this.$event.getIdsByStrId(it))
    const exitPOptions = [rectAttr.rows[1]]
    const exitUid = getAllColsUidInLayoutComponent(exitPOptions)[0]
    const exitLlementInLayout = handleFindLayoutComponentOptions(exitPOptions, exitUid)
    const personMsg = await this.getImgData()
    if (uid == null || personMsg == null || rectAttr.loginStatus == "1") {
      const referer = window.location.href
      const loginurl =
        window.location.protocol +
        "//" +
        window.location.hostname +
        "/login?url=&referer=" +
        encodeURIComponent(referer)
      this.content.$changeOptionsEV(0, "activeIndex", false, null, { ...loginLayouMsg }, true)
      loginLlementInLayout.forEach((element, index) => {
        switch (element.loginType) {
          case "loginBtn":
            this.content.$changeOptionsEV(loginurl, "linkUrl", false, null, {
              uid: loginUid,
              elementInLayoutId: element.elementInLayoutId,
              ...loginLayouMsg
            }, true)
            break
          case "registerBtn":
            // 产品要求 未登录初始化时屏蔽注册按钮
            let registClass =
              "container_id_" +
              loginLayouMsg.container_id +
              "-rect_id_" +
              loginLayouMsg.rect_id +
              "-uid_" +
              loginUid +
              "-elementInLayoutId_" +
              element.elementInLayoutId
            this.content.$changeOptionsEV(0, "opacity", false, null, {
              ...loginLayouMsg,
              uid: loginUid,
              elementInLayoutId: element.elementInLayoutId
            }, true)
            setTimeout(() => {
              if (document.getElementsByClassName(registClass).length > 0) {
                document.getElementsByClassName(registClass)[0].style.display = "none"
              }
            }, 200)
            break
        }
      })
    } else {
      this.content.$changeOptionsEV(1, "activeIndex", false, null, { ...loginLayouMsg }, true)
      // let myCookie = await getCookie("fid,website_fid")
      let myCookie = this.content.$store.state.states.myCookie
      let fid = myCookie.fid
      const name = window.location.protocol + "//" + window.location.hostname
      let webfid = myCookie.website_fid
      if (!this.isEmpty(webfid)) {
        fid = webfid
      }
      const myurl = "http://i.chaoxing.com/base?vflag=true&fid=" + fid + "&backUrl=" + name
      const logoutUrl = window.location.protocol + "//" + window.location.hostname + "/logout?url="
      if (personMsg == "err") return
      exitLlementInLayout.forEach((element, index) => {
        switch (element.loginType) {
          case "loginImage":
            this.content.$changeOptionsEV(personMsg.portrait, "imgSrc", false, null, {
              uid: exitUid,
              elementInLayoutId: element.elementInLayoutId,
              ...loginLayouMsg
            }, true)
            break
          case "loginName":
            // 同步到移动端把名字置空让下拉不占位 避免挡住后面的导航
            let name = this.content.$route.path === "/appHome" && this.isHeader ? "1" : personMsg.realname
            this.content.$changeOptionsEV(name, "selectOptions.0.label", false, null, {
              uid: exitUid,
              elementInLayoutId: element.elementInLayoutId,
              ...loginLayouMsg
            }, true)
            // this.content.$changeOptionsEV(myurl, "selectOptions.0.children.0.value", false, null, {
            //   uid: exitUid,
            //   elementInLayoutId: element.elementInLayoutId,
            //   ...loginLayouMsg
            // })
            let len = element.selectOptions[0].children.length - 1
            let updateValue = "selectOptions.0.children." + len + ".value"
            this.content.$changeOptionsEV(logoutUrl, updateValue, false, null, {
              uid: exitUid,
              elementInLayoutId: element.elementInLayoutId,
              ...loginLayouMsg
            }, true)
            break
          default:
            break
        }
      })
    }
  }
  initWatchers(deep = 0) {
    if (this.content.$route.path === "/appHome" || isSsrPage()) {
      const containerOpt = this.content.$store.state[this.content.request_prefix].page?.pageLayoutList?.length
        ? this.content.$store.state[this.content.request_prefix].page.pageLayoutList.find(
            it => it.options.inDocument === "header"
          )?.options
        : this.content.$store.state[this.content.request_prefix].page.children.find(
            it => it.container_id === this.content.myid.container_id
          ).options
      if (containerOpt?.headComponentMap?.login === this.content.myid.rect_id) {
        this.isHeader = true
        //在头部中且被绑定为头部中的登陆组件 此时需要隐藏掉两个画布中的第二个组件
        const allElementInLayout = getAllElementsInColsInLayoutComponent(this.content.options.rows)
        for (let uid in allElementInLayout) {
          for (let j = 0; j < allElementInLayout[uid].elementOptions.length; j++) {
            const elementInLayout = allElementInLayout[uid].elementOptions[j]
            const { loginType, elementInLayoutId } = elementInLayout
            if (loginType !== "loginImage" && loginType !== "loginBtn") {
              const ids = {
                container_id: this.content.myid.container_id,
                rect_id: this.content.myid.rect_id,
                elementInAutoLayoutId: this.content.myid.elementInAutoLayoutId,
                uid,
                elementInLayoutId
              }
              // this.content.$changeOptionsEV(100, "opacity", false, null, ids, true)
              // this.content.$changeOptionsEV(32, "width", false, null, ids, true)
              // this.content.$changeOptionsEV(32, "height", false, null, ids, true)
              // this.content.$changeOptionsEV(0, "menuOpacity", false, null, ids, true)
              // this.content.$changeOptionsEV(0, "left", false, null, ids, true)
              // this.content.$changeOptionsEV(10, "top", false, null, ids, true)
            }
          }
        }
      }
    }
  }
  isEmpty(str) {
    return typeof str == "undefined" || str == null || "" === $.trim(str)
  }
  async getImgData() {
    let userInfo = this.content.$store.state.states.userInfo
    if (userInfo) {
      return userInfo
    }
    let defaultPortrait = require("../../../../../assets/images/default_portrait.png")
    return new Promise((resolve, reject) => {
      if (process.env.NODE_ENV !== "production") {
        resolve({
          openid4: "",
          portrait: defaultPortrait,
          realname: "张三",
          roleid: "3",
          uid: "53681381",
          uname: ""
        })
      } else {
        this.content.$API.getUserInfo().then(res => {
          if (res.data.code === 1) {
            let userInfo = {
              portrait: res.data.data.uid ? `https://photo.chaoxing.com/p/${res.data.data.uid}_80` : defaultPortrait,
              realname: res.data.data.realname,
              ...res.data.data
            }
            this.content.$store.commit("states/updateUserInfo", userInfo)
            resolve(userInfo)
          } else if (res.data.code === 0 || res.data.data.uid === null) {
            resolve(null)
          } else {
            reject("err")
          }
        })
      }
    })
  }
}
export default {
  methods: {
    async loginLayoutComponent() {
      await new loginLayoutComponentClass(this).init()
    }
  }
}
